import { render, staticRenderFns } from "./HumanizeDate.vue?vue&type=template&id=25ccbf78&scoped=true&"
import script from "./HumanizeDate.vue?vue&type=script&lang=ts&"
export * from "./HumanizeDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ccbf78",
  null
  
)

export default component.exports